import { NotificationType } from '@/common/constants/common.constants';
import i18n from '@/common/i18n';
import { useNotifications } from '@/common/utils/notifications/notificationsPlugin';

export const enum DiskCleanupStatus {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}

const getDiskCleanupNotification = (status: DiskCleanupStatus, migrationName: string) => ({
  [DiskCleanupStatus.RUNNING]: {
    type: NotificationType.INFO,
    title: i18n.t('Disk cleanup started'),
    message: i18n.t('Disk cleanup for migration "{name}" started', { name: migrationName })
  },
  [DiskCleanupStatus.COMPLETED]: {
    type: NotificationType.SUCCESS,
    title: i18n.t('Cleanup completed'),
    message: i18n.t('Disks for migration "{name}" have been cleaned up', { name: migrationName })
  },
  [DiskCleanupStatus.ERROR]: {
    type: NotificationType.ERROR,
    title: i18n.t('Failed to clean up disks'),
    message: i18n.t('Failed to clean up disks for migration "{name}"', { name: migrationName })
  }
}[status]);

export const notifyDiskCleanupStatusChange = (
  status: DiskCleanupStatus | undefined,
  migrationId: string,
  migrationName: string
) => {
  if (!status) return;

  const notification = getDiskCleanupNotification(status, migrationName);
  if (!notification) return;

  const { notify } = useNotifications();
  notify({
    type: notification.type,
    title: notification.title,
    message: notification.message,
    operationId: `disks-cleanup-${status}-${migrationId}`,
    showBottom: true
  });
};
